const ACTIVE_TENANT_ID_KEY = 'trushelf.portal.activeTenantId';

export function getActiveTenantId(): string | null {
  return localStorage.getItem(ACTIVE_TENANT_ID_KEY);
}

export function setActiveTenantId(tenantId: string): void {
  localStorage.setItem(ACTIVE_TENANT_ID_KEY, tenantId);
}

export function clearActiveTenantId(): void {
  localStorage.removeItem(ACTIVE_TENANT_ID_KEY);
}
